import { AfterViewChecked, Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BehaviorSubject, debounceTime, Observable, Subscription } from 'rxjs';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { BENEFITS_KEY } from 'src/app/components/Price-subscritions/priceplanService';
import { ApiService } from 'src/app/services/api.service';
import { AppSettings } from 'src/app/services/AppSettings';
import { ExcelService } from 'src/app/services/excelService';
import { FormValidation } from 'src/app/services/FormValidation';
import { GigsumoConstants } from 'src/app/services/GigsumoConstants';
import { GigsumoService } from 'src/app/services/gigsumoService';
import { UtilService } from 'src/app/services/util.service';
import Swal from 'sweetalert2';
import { CustomerService, TEXT_FIELDS } from '../customer-service.service';
import { UpgradeMessageComponent } from 'src/app/upgrade-message/upgrade-message.component';
import { ManageSlotComponent } from '../manage-slot/manage-slot.component';
import { PlanCardComponent } from '../plan-card/plan-card.component';
import { CustomerSearchComponent } from '../customer-search/customer-search.component';
import { RouterModule } from '@angular/router';
import { MtaFilterPipe } from 'src/app/pipe/name-filter.pipe';
import { TimezoneDatePipe } from 'src/app/timezone-date.pipe';
import { NodataFoundComponent } from '../../../../widget/nodata-found/nodata-found.component';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: 'app-customer-workspace',
  standalone: true,
  imports: [CommonModule, RouterModule, NgxDatatableModule,
UpgradeMessageComponent, ManageSlotComponent, PlanCardComponent, CustomerSearchComponent, MtaFilterPipe, TimezoneDatePipe, TitleCasePipe, NodataFoundComponent,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './customer-workspace.component.html',
  styleUrls: ['./customer-workspace.component.scss', '../../../../../styles/admin/style.scss', '../../../../../styles/admin/app.scss']
})
export class CustomerWorkspaceComponent extends FormValidation implements OnInit, OnDestroy, AfterViewChecked {
  public listToShow: Array<any>;
  PLANMAX: any;
  AVAILABLE: any;
  ALLOCATED: any;
  textFields: Array<Partial<TEXT_FIELDS>>;
  plan: any;
  businessOwner: any;
  MemberShipType: any;
  isBusinessOrEnterpriseUser: boolean = false;
  bid: string;
  userPayload: any = {
    limit: 10,
    page: 1,
    total: 0
  };
  refreshSubcription: Subscription;
  filterSubscription: Subscription;
  searchSubscription: Subscription;
  businessData: any;
  slotPayload: any = {
    type: "TEAM_WORKSPACES",
    limit: 10,
    page: 0,
    searchAfterKey: null,
    statusList: ["ACTIVE", "INACTIVE", "BLOCKED"],
    groupType: "MANAGE"
  }
  businessDetails: any;
  openSlotSubscription: Subscription;
  prevSearchAfterKey: any;
  stopScroll: boolean = false;
  public slotData = new BehaviorSubject([]);
  slotModalOpen: boolean = false;
  slotPlanDetails: any = {};
  allocationCards = [
    {
      id: "",
      name: "Plan Max",
      value: 0
    },
    {
      id: "SLOT_ALLOCATED",
      name: "Allocated",
      value: 0
    },
    {
      id: "SLOT_MAX",
      name: "Available",
      value: 0
    },
  ];
  slotAllocatedCards: { name: string; value: number }[] = [];
  role: any
  constructor(
    private router: Router,
    private _activated_route: ActivatedRoute,
    private _api_service: ApiService,
    public util: UtilService,
    private excel: ExcelService,
    private customerService: CustomerService,
    private modalService: BsModalService,
    private gigsumoService: GigsumoService,
    private renderer: Renderer2, private el: ElementRef,
  ) {
    super();
    this._activated_route.parent.data.subscribe(res => {
      this.businessData = res.data;
      this.MemberShipType = this.businessData.plan;
      this.role = this.businessData.role;
      this.slotPayload.businessId = this.businessData.id;
      this.slotPayload.email = this.businessData.businessEmail;
      this.businessDetails = res.data;
    });
    const defaultValues = this.MemberShipType === "Free"
      ? [5, 0, 5]
      : [null, null, null];


    this.allocationCards[0].value = this.PLANMAX;
    this.allocationCards[1].value = this.ALLOCATED;
    this.allocationCards[2].value = this.AVAILABLE;
    this.slotAllocatedCards = structuredClone(this.allocationCards);

    this.textFields = [
      { label: "Workspace Name", key: "teamName", value: null, type: "STRING" },
      { label: "User", key: "owner", value: null, type: "STRING" },
      { label: "Email ID", key: "username", value: null, type: "STRING" },
      { label: "Role", key: "userType", value: null, type: "STRING" },
      { label: "Members", key: "memberCnt", value: null, type: "STRING" },
      { label: "Start Date", key: "createdOn", value: null, type: "DATE" },
      { label: "Last Active", key: "modifiedOn", value: null, type: "DATE" },
      { label: "Status", key: "status", value: null, type: "STRING" },
    ];

    this.refreshSubcription = this.customerService.getRefreshKey().subscribe(ress => {
      if (ress === "workSpace") {
        this.fetchData(this.businessData.id);
      }
    });


    this.filterSubscription = this.customerService.getFilterValue().subscribe(res => {
      if (res.key === 'workSpace') {
        this.userPayload.page = 1;
        this.userPayload.status = res.value.status;
        this.userPayload.searchContent = null;
        if (res.value.status == null) {
          this.userPayload.statusList = ["ACTIVE", "INACTIVE", "BLOCKED"]
        }
        this.customerService.setFilterPayload(this.userPayload);
        this.fetchData(this.businessData.id);
      }
    });


    this.searchSubscription = this.customerService.getSearchValue().pipe(
      debounceTime(1000),
    ).subscribe(response => {
      if (response.key === "workSpace") {
        console.log(response.value, response.key);
        this.userPayload.page = 1;
        this.userPayload.searchContent = response.value;
        if (response.value.status == null) {
          this.userPayload.statusList = ["ACTIVE", "INACTIVE", "BLOCKED"]
        }
        this.fetchData(this.businessData.id);
      }
    });


    this.openSlotSubscription = this.customerService.getSlotModal().subscribe(res => {
      if (res.key === "workSpace") {
        if (res.value.status == null) {
          this.userPayload.statusList = ["ACTIVE"]
        }
        this.slotPayload.statusList = ["ACTIVE", "INACTIVE", "BLOCKED"]
        this.fetchSlotData();
        this.slotPlanDetails = res.value;
      }
    });


  }

  getWorkspaceParams(row) {
    return { ...this.businessDetails, teamId: row.teamId };
  }
  @ViewChild('sortTable') table: any;
  onSort(event) {
    const currentPage = this.userPayload.page;
    this.table.offset = currentPage;
  }

  ngOnInit(): void {
    if (this.businessData.id) {
      this.userPayload.statusList = ["ACTIVE", "INACTIVE", "BLOCKED"];
      this.fetchData(this.businessData.id);
      this.fetchUser();
    }
    this.checkUserPlan(this.MemberShipType);
  }

  checkUserPlan(memberShipType: string) {
    this.isBusinessOrEnterpriseUser = this.customerService.isBusinessOrEnterprise(memberShipType);
  }

  scrollSynced = false; // Flag to prevent multiple bindings
  bodyScrollUnlistener: () => void; // To store the unlistener for clean-up
  resizeUnlistener: () => void; // To store resize unlistener

  ngAfterViewChecked() {
    const dataTableBody = this.el.nativeElement.querySelector('.datatable-body');
    const dataTableHeader = this.el.nativeElement.querySelector('.datatable-header');

    if (!this.isFirefox()) {
      // If it's not Firefox, no need for custom scroll handling
      return;
    }

    if (dataTableBody && dataTableHeader && !this.scrollSynced) {
      // Clean up any previous listeners to avoid duplicates
      if (this.bodyScrollUnlistener) {
        this.bodyScrollUnlistener();
      }
      if (this.resizeUnlistener) {
        this.resizeUnlistener();
      }

      // Scroll listener to sync body and header scrolls
      this.bodyScrollUnlistener = this.renderer.listen(dataTableBody, 'scroll', this.throttle(() => {
        dataTableHeader.scrollLeft = dataTableBody.scrollLeft;
      }, 10)); // Throttle the scroll event to improve performance

      // Listener for window resize to ensure the header remains aligned
      this.resizeUnlistener = this.renderer.listen(window, 'resize', () => {
        dataTableHeader.scrollLeft = dataTableBody.scrollLeft;
      });

      this.scrollSynced = true; // Mark scroll syncing as done
    }
  }

  // Browser detection function to check if the browser is Firefox
  isFirefox(): boolean {
    return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
  }


  throttle(fn: Function, wait: number) {
    let time = Date.now();
    return function () {
      if ((time + wait - Date.now()) < 0) {
        fn();
        time = Date.now();
      }
    };
  }

  ngOnDestroy(): void {

    if (this.refreshSubcription) {
      this.refreshSubcription.unsubscribe();
    }

    if (this.filterSubscription) {
      this.filterSubscription.unsubscribe();
    }

    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }

    if (this.openSlotSubscription) {
      this.openSlotSubscription.unsubscribe();
    }

    if (this.bodyScrollUnlistener) {
      this.bodyScrollUnlistener();
    }

    if (this.resizeUnlistener) {
      this.resizeUnlistener();
    }
  }


  nextPage(data: any) {
    this.userPayload.page = data.offset + 1;
    if (this.userPayload.page == 1) {
      this.userPayload.page = 1;
    }
    this.fetchData(this.businessData.id);
  }

  public selected = [];
  onSelect({ selected }) {
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }

  getBusinessTeamsList(payload: Object): Observable<any> {
    return this._api_service.create('teams/findTeamsOfBusiness', payload);
  }
  getemployeeteamlist(payload: Object): Observable<any> {
    return this._api_service.create('teams/findUserOwnedTeams', payload);
  }
  payload: any = {
    limit: 10,
    page: 0,
    // statusList: ["ACTIVE", "INACTIVE", "BLOCKED"],
    groupType: "LISTING"
  };


  fetchUser() {
    this.payload.businessId = this.businessData.id;
    this.payload.email = this.businessData.businessEmail;
    this.payload.type = "TEAM_WORKSPACES";
    this._api_service.create('subscription/findEmployeeBenefitsAllocation', this.payload).subscribe(res => {
      if (res.code === AppSettings.SUCESS_CODE) {
        const data = res.data.customerUserAllocationList;
        data.forEach(x => {
          x.userType = x.userType.replaceAll("_", " ");
        });
        this.customerService.setUser(data);
      }
    });
  }


  fetchData(businessId: string) {
    this.userPayload.businessId = businessId;
    this.util.startLoader();

    if (this.role !== 'EMPLOYEE' && this.role !== 'ADMIN') {
      this.getBusinessTeamsList(this.userPayload)
        .subscribe(response => this.handleResponse(response, 'customerPlanUsage'));
    } else {
      this.userPayload.userId = localStorage.getItem('userId');
      this.userPayload.page = 0;
      this.getemployeeteamlist(this.userPayload)
        .subscribe(response => this.handleResponse(response, 'userPlanUsage'));
    }
  }

  private handleResponse(res: any, planKey: string) {
    this.util.stopLoader();
    if (res && res.code === AppSettings.SUCESS_CODE) {
      const mappedData = res.data.teams.map(ele => {
        const { userDetail, ...rest } = ele;
        return {
          ...rest,
          owner: `${userDetail.firstName} ${userDetail.lastName}`,
          userType: userDetail.userType.replaceAll("_", " "),
          username: userDetail.email
        };
      });

      this.customerService.setUserData(mappedData);
      this.listToShow = mappedData;
      this.userPayload.total = res.data.total;
      this.excel.setCount(this.userPayload.total);
      this.updatePlanUsage(res.data[planKey]);
    } else {
      this.showError();
    }
  }
  private updatePlanUsage(plan: any) {
    if (plan) {
      const found = plan.benefitsUsages?.find(
        (x) => (x.benefitKey as BENEFITS_KEY) === "TEAM_WORKSPACES"
      );
      if (found) {
        this.PLANMAX = found.actual;
        this.AVAILABLE = found.available;
        this.ALLOCATED = found.utilized;
        this.allocationCards[0].value = this.PLANMAX;
        this.allocationCards[1].value = this.ALLOCATED;
        this.allocationCards[2].value = this.AVAILABLE;
        this.slotAllocatedCards = structuredClone(this.allocationCards);
      }
    }
  }

  private showError() {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "An error occurred while fetching data. Please try again later.",
    });
  }

  convertToTitleCase(str) {
    return str
      .toLowerCase()
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }


  fetchSlotData() {
    this.util.startLoader();
    this._api_service.create('subscription/findEmployeeBenefitsAllocation', this.slotPayload)
      .subscribe({
        next: (response) => {
          this.util.stopLoader();
          if (response && response.code === GigsumoConstants.SUCESSCODE) {

            const users = response.data.customerUserAllocationList;
            users.forEach(x => {
              x.userType = this.convertToTitleCase(x.userType);
            })
            const searchKey = response.data.searchAfterKey;

            if (users) {
              const current = users;
              const exist = this.slotData.getValue();
              let sortDuplicates = this.gigsumoService.removeDuplicatesKey([...exist, ...current], 'userId');
              this.slotData.next(sortDuplicates);
            }

            if (users != null && (users.length === 0 || JSON.stringify(this.prevSearchAfterKey) === JSON.stringify(searchKey))) {
              this.stopScroll = true;
            }

            this.prevSearchAfterKey = searchKey;
            this.slotModalOpen = true;
          }
        },
        error: (error) => {
          console.error('Subscribe Error:', error); // Log any error in the subscribe block
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "An error occurred while fetching data. Please try again later.",
          });
        }
      });
  }


  handleInvalidSession() {
    Swal.fire({
      icon: "info",
      title: "Invalid session",
      text: "Sorry, your session has expired. We are routing you to login page.",
      showConfirmButton: false,
      timer: 5000,
    }).then(() => {
      localStorage.clear();
      this.router.navigate(['/auth/login']);
      this.util.stopLoader();
      Swal.close();
    });
  }

  openEdit(datas: any) {

    if (datas) {
      Object.keys(datas).map(key => {
        this.textFields.forEach(vv => {

          if (vv.key == key) {
            vv.value = datas[key];
          }

          if (vv.key === "userType") {
            vv.value = datas[vv.key] ? this.util.userAlias(datas[vv.key]) : "N/A";
            return;
          }

        });
      });
    }

    if (this.textFields) {
      this.openView("Workspaces", this.textFields, this.modalService, this.util);
    }

  }

  getTeamParams(row) {
    return { ...this.businessData, teamId: row.teamId, };
  }

  onScroll() {
    if (!this.stopScroll) {
      this.slotPayload = {
        ...this.slotPayload,
        searchAfterKey: this.prevSearchAfterKey
      }
      this.fetchSlotData();
    }
  }

  onClose(d) {
    this.resetSlot();
  }

  onSucess(d) {
    if (d === "SUCCESS") {
      this.resetSlot();
    }
  }

  resetSlot() {
    this.slotData.next([]);
    this.slotPayload.searchAfterKey = null;
    this.prevSearchAfterKey = null;
    this.slotPayload.searchContent = '';
    this.slotModalOpen = false;
    this.stopScroll = false;
  }


  onSearch(v) {
    this.slotData.next([]);
    this.slotPayload.searchAfterKey = null;
    this.prevSearchAfterKey = null;
    this.stopScroll = false;
    this.slotPayload.searchContent = v;
    this.fetchSlotData();
  }


}
